export const R_VOUCHER_PLAN = '/voucher/plan';
export const R_VOUCHER_SIGNIN = '/voucher/signin';
export const R_VOUCHER_ACCOUNT = '/voucher/account';
export const R_VOUCHER_SIGNUP = '/voucher/signup';
export const R_ACCOUNT_SETTINGS = '/account/settings';
export const R_ACCOUNT_PAYMENT =  '/voucher/payment'